import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { OrderProvider } from './context/OrderContext';
import { NotificationProvider } from './context/NotificationContext';
import Layout from './components/layout/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Customers from './pages/Customers';
import Services from './pages/Services';
import Orders from './pages/Orders';
import POS from './pages/POS';
import Payments from './pages/Payments';
import Subscriptions from './pages/Subscriptions';
import NotFound from './pages/NotFound';
import ProtectedRoute from './components/common/ProtectedRoute';
import PaymentSystem from './components/payments/PaymentSystem';
import OrderManagement from './components/orders/OrderManagement';
import CustomerManagement from './components/customers/CustomerManagement';
import SubscriptionManagement from './components/subscriptions/SubscriptionManagement';
import PlanManagement from './components/subscriptions/PlanManagement';
import PaymentManagement from './components/payments/PaymentManagement';
import DashboardManagement from './components/layout/DashboardManagement';
import RoleManagement from './components/roles/RoleManagement';
import ServiceManagement from './components/services/ServiceManagement';

function App() {
  return (
    <Router>
      <AuthProvider>
        <NotificationProvider>
          <OrderProvider>
            <Routes>
              <Route path="/login" element={<Login />} />
              
              <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="/dashboard" element={<DashboardManagement />} />
                <Route path="/pos" element={<POS />} />
                <Route path="/customers" element={<CustomerManagement />} />
                <Route path="/subscriptions" element={<SubscriptionManagement />} />
                <Route path="/subscriptions/plans" element={<PlanManagement />} />
                <Route path="/services"      element={<ServiceManagement />} />
                <Route path="/orders" element={<OrderManagement />} />
                <Route path="/payments" element={<PaymentSystem />} />
                <Route path="/roles"         element={<RoleManagement />} />
              </Route>
              
              <Route path="*" element={<NotFound />} />
            </Routes>
          </OrderProvider>
        </NotificationProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
